import { FEATURE_CATEGORIES } from '@/content/features';
import FeatureCategory from './FeatureCategory';

/**
 * FeatureCategoriesSection Component
 * Displays all feature categories in an accordion layout
 * First category is open by default
 */
export default function FeatureCategoriesSection() {
  return (
    <section className="py-16 md:py-24 bg-brand-light dark:bg-secondary-900">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-secondary-900 dark:text-secondary-50 mb-4">
            Deep Dive: How It Works
          </h2>
          <p className="text-lg text-secondary-700 dark:text-secondary-300 max-w-2xl mx-auto">
            Explore the details of each feature category and understand how Notematic supports your clinical practice.
          </p>
        </div>

        {/* Categories */}
        <div className="space-y-4">
          {FEATURE_CATEGORIES.map((category, index) => (
            <FeatureCategory
              key={category.id}
              category={category}
              defaultOpen={index === 0} // First category open by default
            />
          ))}
        </div>
      </div>
    </section>
  );
}

